import { Observable } from 'rxjs';
import { Rpc } from '../rpc';
import { RpcObservableClient } from '../rpc-observable-client';
import { RpcOutbound } from '../rpc-outbound';
import {
    RpcObservableCopilotConfigRequest, RpcObservableCopilotError, RpcObservableCopilotKey, RpcObservableCopilotResult
} from './rpc-observable-copilot-model';

/**
 * Shell to Iframe pair, the sending/Shell port.
 */
export class RpcObservableCopilotConfigClient
    extends RpcObservableClient<RpcObservableCopilotConfigRequest, RpcObservableCopilotResult, RpcObservableCopilotError>  {

    /**
     * Initializes a new instance of the RpcObservableCopilotConfigClient class.
     *
     * @param rpc the rpc object.
     */
    constructor(rpc: Rpc) {
        super(rpc, RpcObservableCopilotKey.configCommand, RpcObservableCopilotKey.version);
    }

    /**
     * The Copilot config command.
     *
     * @param request the Rpc Copilot config object.
     * @param outbound the Rpc outbound channel object.
     * @return Observable<RpcObservableCopilotResult> the observable object.
     */
    public config(request: RpcObservableCopilotConfigRequest, outbound?: RpcOutbound): Observable<RpcObservableCopilotResult> {
        return this.observableCall(request, outbound);
    }
}
